import http from '@/http'
import moment from 'moment'
import { toISO8601 } from '@/utils'
export default {
  namespaced: true,
  state: {
    subscription: {},
    subscriptionCycle: {},
    reactiveSubscription: false,
    subscriptionCycleDaysLeft: 0,
    canShowInformationToast: true
  },
  mutations: {
    setSubscription(state, subscription) {
      state.subscription = subscription
    },
    setSubscriptionCycle(state, subscriptionCycle) {
      state.subscriptionCycle = subscriptionCycle
    },
    setReactiveSubscription(state, reactiveSubscription) {
      state.reactiveSubscription = reactiveSubscription
    },
    setSubscriptionCycleDaysLeft(state, subscriptionCycleDaysLeft) {
      state.subscriptionCycleDaysLeft = subscriptionCycleDaysLeft
    },
    setCanShowInformationToast(state, canShowInformationToast) {
      state.canShowInformationToast = canShowInformationToast
    }
  },
  actions: {
    async updateMe({}, _user) {
      try {
        const _toBeUpdated = JSON.parse(JSON.stringify(_user))
        if (_toBeUpdated.userBirthdate) _toBeUpdated.userBirthdate = toISO8601(_toBeUpdated.userBirthdate)
        if (!_toBeUpdated.userAddress.country) _toBeUpdated.userAddress.country = 'Brazil'

        const response = await http.put('/user/updateMe', _toBeUpdated)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async uploadPhoto({}, photo) {
      try {
        const response = await http.post('/user/uploadPhoto', photo)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async readPayment({ commit, dispatch }) {
      try {
        const response = await http.get('/user/readPayment')
        commit('setSubscription', response.data.data.subscription)
        commit('setSubscriptionCycle', response.data.data.subscription_cycle)
        dispatch('getSubscriptionDaysLeft', response.data.data.subscription_cycle)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async unsubscribe({}, _props) {
      try {
        const response = await http.post('/user/register/unsubscribe', _props)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async changePassword({}, userData) {
      try {
        const response = await http.post('/user/changePassword', userData)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    getSubscriptionDaysLeft({ commit }, subscriptionCycle) {
      const now = moment(new Date())
      const end = moment(subscriptionCycle.endDate)
      const duration = moment.duration(end.diff(now))
      const days = duration.asDays()
      commit('setSubscriptionCycleDaysLeft', days.toFixed(0))
    }
  },
  getters: {
    subscription: state => state.subscription,
    subscriptionCycle: state => state.subscriptionCycle,
    reactiveSubscription: state => state.reactiveSubscription,
    canShowInformationToast: state => state.canShowInformationToast,
    subscriptionCycleDaysLeft: state => state.subscriptionCycleDaysLeft
  }
}
